import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
export type _FavoriteIconCssType =
  | 'star-default'
  | 'heart-default'
  | 'circle-default'
  | 'circle-small'
  | 'rectangle-star'
export abstract class _FavoriteIconBase extends BaseCssVarValue {
  abstract cssType: _FavoriteIconCssType
  /** 收藏图标定位上边距 */
  ['--favorited-icon-top']?: string;
  /** 收藏图标定位右边距 */
  ['--favorited-icon-right']?: string;
  /** 收藏图标定位下边距 */
  ['--favorited-icon-bottom']?: string;
  /** 收藏图标定位左边距 */
  ['--favorited-icon-left']?: string

  // 暂时不删除它们,万一后面在每个子图标中用得上
  // /** 收藏图标尺寸(宽高) */
  // ['--favorited-icon-side']?: string;
  // /** 收藏图标缩放 */
  // ['--canvas-box-transform']?: string;
  // /** 点击区域四方扩大尺寸(注:单位为 - ,例:四方扩大5px,则填 -5px ) */
  // ['--click-arean-expand-size']?: string
}

export type _FavoriteIconCssVar = GetCssVarManager<_FavoriteIconBase>
